export enum InfiniteLoadMoreExperimentVariants {
	Control = 'control',
	InfiniteList = 'infinite_list',
	Off = 'off',
}
